import React, { createContext, useState, useEffect, useContext } from 'react';

// Create a context for terms consent
const TermsConsentContext = createContext();

// Provider component that wraps the entire app
export const TermsConsentProvider = ({ children }) => {
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  
  // Check consent status when component mounts
  useEffect(() => {
    checkConsentStatus();
  }, []);
  
  // Function to check if consent is valid
  const checkConsentStatus = () => {
    const termsAccepted = localStorage.getItem('termsAccepted');
    const termsAcceptedDate = localStorage.getItem('termsAcceptedDate');
    
    // If terms haven't been accepted yet
    if (!termsAccepted) {
      setShowConsentPopup(true);
      return;
    }
    
    // If terms were accepted, but we need to check the date
    if (termsAcceptedDate) {
      const acceptedDate = new Date(termsAcceptedDate);
      const currentDate = new Date();
      
      // Calculate the difference in days
      const dayDifference = Math.floor(
        (currentDate - acceptedDate) / (1000 * 60 * 60 * 24)
      );
      
      // If more than 1 day has passed, show popup again
      if (dayDifference >= 1) {
        setShowConsentPopup(true);
      }
    } else {
      // If no date was stored (for backwards compatibility)
      // Store current date and don't show popup
      const currentDate = new Date().toISOString();
      localStorage.setItem('termsAcceptedDate', currentDate);
    }
  };
  
  // Function to handle acceptance
  const handleAccept = () => {
    const currentDate = new Date().toISOString();
    localStorage.setItem('termsAccepted', 'true');
    localStorage.setItem('termsAcceptedDate', currentDate);
    setShowConsentPopup(false);
  };
  
  // Function to handle decline
  const handleDecline = () => {
    // Redirect to Google
    window.location.href = "https://www.google.com";
  };
  
  // Value to be provided by the context
  const contextValue = {
    showConsentPopup,
    handleAccept,
    handleDecline,
  };
  
  return (
    <TermsConsentContext.Provider value={contextValue}>
      {children}
    </TermsConsentContext.Provider>
  );
};

// Custom hook to use the terms consent context
export const useTermsConsent = () => {
  return useContext(TermsConsentContext);
};